import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap'
import HeadquarterView from './HeadquarterView';
import ResaleView from './ResaleView';
import MasterAgentView from './MasterAgentView';
import { useCompany, useUser } from 'models';

export default function () {
  const user = useUser()
  const { company } = useCompany()

  const [showNotification, setShowNotification] = useState(()=>{
    let read_notication = localStorage.getItem("read_notication");
    return !!!read_notication;
  });

  function notification(){
    function handleClose(){
      setShowNotification(false);
      localStorage.setItem("read_notication", true);
    }
    var strData = "09/06/2025";
    var partesData = strData.split("/");
    var data = new Date(partesData[2], partesData[1] - 1, partesData[0]);
    // if(data < new Date()){
    //   return (
    //     <Modal show={showNotification} onHide={handleClose}>
    //       <Modal.Header closeButton>
    //         <Modal.Title>Notificação</Modal.Title>
    //       </Modal.Header>
    //       <Modal.Body>
    //         <div>
    //           O Programa ScanSource Select 2025 se encerrou e, com isso, a apuração das verbas também. A partir de agora só faremos a atualização semanalmente dos valores que estão em "aguardando liberação", que serão liberados conforme pagamento dos pedidos parcelados.
    //         </div>
    //         <div>
    //           O prazo para resgate da verba será até 20/12/2025.
    //         </div>
    //       </Modal.Body>
    //       <Modal.Footer>
    //         <Button variant="secondary" onClick={handleClose}>
    //           OK
    //         </Button>
    //       </Modal.Footer>
    //     </Modal>
    //   );
    // }

    return <></>;
  }


  const isElite = () => {    
    return company && getCompanyFiscalYear() ? getCompanyFiscalYear().is_premium : user.isElite();
    //return company ? company.is_premium : user.isElite();
  }

  const isMasterAgent = () => {
    return company && getCompanyFiscalYear() ? getCompanyFiscalYear().is_masteragent : user.isMasterAgent();
  }

  const getCompanyFiscalYear = () => {
    if (company && company.adhesion && company.adhesion.length > 0) {
      const { fiscal_year_id } = company.adhesion.map(adhesion => ({ fiscal_year_id: adhesion.fiscal_year_id }))[0]
      const cfy = company.all_company_fiscal_years.find(year => fiscal_year_id == year.fiscal_year_id)
      return cfy
    } 
    else {
      return { is_premium: company.is_premium, is_masteragent: company.is_masteragent }
    }
    return null
  }

  const [showDashboard, setShowDashboard] = useState(null);

  useEffect(() => {
    if (company) {
      if (isMasterAgent() && !isElite()) setShowDashboard('masteragent')
      if (!isMasterAgent() && isElite()) setShowDashboard('elite')
    }
  }, [])

  if (isElite() && isMasterAgent()) {
    if (showDashboard) {
      if (showDashboard == "elite") {
        if (!!company)
          return (<><ResaleView user={user} currentCompany={company} /></>);
        else
          return (<><HeadquarterView user={user} /></>);
      } else {
        return (<><MasterAgentView user={user} /></>);
      }
    }

    return (<>
      {/* {notification()} */}
      <Container fluid>
        <Row>
          <Col md="4" className="mt-4">
            <Card.Body style={{ color: "#787878" }} className="d-flex flex-column shadow bg-white rounded m-2 col-12 text-center">
              <h4>Dashboard Elite</h4>
              <Button
                className="mt-2"
                onClick={() => setShowDashboard("elite")}
              >
                Acessar
              </Button>
            </Card.Body>
          </Col>

          <Col md="4" className="mt-4">
            <Card.Body className="d-flex flex-column shadow bg-white rounded m-2 col-12 text-center">
              <h4>Dashboard Master Agent</h4>
              <Button
                className="mt-2"
                onClick={() => setShowDashboard("masterAgent")}
              >
                Acessar
              </Button>
            </Card.Body>
          </Col>
        </Row>
      </Container>
    </>
    )
  }

  if (isElite()) {
    if (!!company) {
      if (isElite())
        return (<>{notification()}<ResaleView user={user} currentCompany={company} /></>);
      else if (isMasterAgent())
        return (<><MasterAgentView user={user} /></>);
    } else {
      return (<><HeadquarterView user={user} /></>);
    }
  }

  if (isMasterAgent()) {
    return (<><MasterAgentView user={user} /></>);
  }
  return <></>
};
